// dependencies
import React from "react";

// components
import { ICellRendererParams, Link, PYColumnDef, Text } from "@performyard/py-components";

import Chip from "../../../../../../components/Chip";
import { Grid } from "../../../../../../components/Grid";

// types
import type { ReviewCycle } from "../../../../../../api/services/searchServiceResultTypes/reviewCycles";

//css
import css from "../ReviewCycles.module.scss";

const NameCellRenderer = (params: ICellRendererParams<ReviewCycle>) => {
	const reviewCycle = params.data;
	if (!reviewCycle) return null;

	const { name, _id } = reviewCycle;

	return (
		<div className="flex h-full items-center">
			<Link href={`/review-cycle/${_id}/`}>
				<Text size="paragraph-3" dangerouslySetClassName="py-line-clamp-1">
					{name}
				</Text>
			</Link>
		</div>
	);
};

const ChipsCellRenderer = (params: ICellRendererParams<ReviewCycle>) => {
	const reviewCycle = params.data;
	if (!reviewCycle) return null;

	const easyAdd = reviewCycle["360_count"];
	const automationStatus = reviewCycle.automation_status;

	return (
		<Grid cols={1} gap={1} className={css.reviewCycleStatusChipsGrid}>
			{["active", "scheduled"].includes(automationStatus ?? "") && (
				<Chip color="green" label="Automated" className={css.statusChip} />
			)}
			{easyAdd > 0 && <Chip color="blue" label="360 Enabled" className={css.statusChip} />}
		</Grid>
	);
};

const StatusCellRenderer = (params: ICellRendererParams<ReviewCycle>) => {
	const reviewCycle = params.data;
	if (!reviewCycle) return null;

	const { status, reviews, completed_reviews } = reviewCycle;
	const statusText = `${status} (${completed_reviews?.length}/${reviews?.length || 0})`;

	return (
		<div className="flex h-full items-center">
			<Text size="paragraph-3" dangerouslySetClassName="py-line-clamp-1">
				{statusText}
			</Text>
		</div>
	);
};

const getReviewCycleTableCols = (): PYColumnDef<ReviewCycle>[] => {
	return [
		{
			field: "name",
			headerName: "Name",
			sortable: true,
			resizable: false,
			width: 456,
			cellRenderer: NameCellRenderer,
		},
		{
			field: "review_cycle_status_chips",
			headerName: "",
			sortable: false,
			resizable: false,
			width: 238,
			cellRenderer: ChipsCellRenderer,
		},
		{
			field: "start_date",
			headerName: "Start Date",
			sortable: true,
			resizable: false,
			width: 180,
			type: "date",
			cellRendererParams: {
				dateFormat: "MMM dd, yyyy h:mm a",
			},
		},
		{
			field: "status",
			headerName: "Status",
			sortable: true,
			resizable: false,
			width: 220,
			cellRenderer: StatusCellRenderer,
		},
	];
};

export default getReviewCycleTableCols;
